export var version = '0.0.3-alpha.5';
// 类型定义导出
export * from './types';
export { Tooltip } from './tooltip';
export { CategoryLegend, ContinueLegend } from './legend';
//# sourceMappingURL=index.js.map